import SDModal from '@/shared/components/SDComponentsNewDesign/SDModal/SDModal'
import useScheduleCallback from './useScheduleCallback'
import { useTranslation } from 'react-i18next'
import ScheduleCallbackModalContent from '@/containers/SubscriptionFormPageNew/Components/ScheduleCallback/ScheduleCallbackModalContent'
import IconPhoneCallback from '@/shared/icons/NewDesign/IconPhoneCallback'
import { StatefulPopover } from 'baseui/popover'
import ScheduleCallbackPopOverContent from '@/containers/SubscriptionFormPageNew/Components/ScheduleCallback/ScheduleCallbackPopOverContent'
import {
  TriggerButton,
  TriggerIcon,
  TriggerText,
  TriggerWrapper,
  BadgeDot,
} from '@/containers/SubscriptionFormPageNew/Components/ScheduleCallback/styled-components'
import useScheduleCallbackInit from '@/containers/SubscriptionFormPageNew/Components/ScheduleCallback/useScheduleCallbackInit'
import TodayCallbacks from '@/containers/SubscriptionFormPageNew/Components/ScheduleCallback/TodayCallbacks/TodayCallbacks'

const ScheduleCallback = () => {
  const { t } = useTranslation()
  useScheduleCallbackInit()
  const {
    success,
    isOpen,
    setIsOpen,
    openModal,
    hasUpcoming,
    triggerTextKey,
    isAllowedCountry,
    plainIcon,
    inRedesignedPanel,
    iconTitleProps,
  } = useScheduleCallback()

  if (!isAllowedCountry) return null

  return (
    <>
      <TriggerWrapper $spacedBelow={!plainIcon}>
        <StatefulPopover
          content={<ScheduleCallbackPopOverContent />}
          accessibilityType={'tooltip'}
          placement='bottomLeft'
          returnFocus
          focusLock={false}
          triggerType='hover'
          overrides={{
            Body: { style: { zIndex: 1000 } },
          }}
        >
          <TriggerButton
            onClick={() => openModal(setIsOpen)}
            aria-label={t('subscriptionTools:schedule_callback.schedule_button')}
            $plainIcon={plainIcon}
            $inRedesignedPanel={inRedesignedPanel}
          >
            <TriggerIcon data-role='trigger-icon' $plain={plainIcon}>
              <IconPhoneCallback size={16} {...iconTitleProps} />
              {hasUpcoming && <BadgeDot title={t('common:callback_already_scheduled')} />}
            </TriggerIcon>
            <TriggerText>{t(triggerTextKey)}</TriggerText>
          </TriggerButton>
        </StatefulPopover>
        <TodayCallbacks />
      </TriggerWrapper>

      <SDModal
        backgroundImage={!success ? { image: 'scene' } : undefined}
        openHandler={setIsOpen}
        isOpen={isOpen}
        hideHeaderActions={success}
        sections={<ScheduleCallbackModalContent />}
      />
    </>
  )
}

export default ScheduleCallback
